<script>
    import Token from "./Token"

    import { authService } from "../../services"

    export default {
        name: "Auth",
        mixins: [ Token ],
        data() {
            return {
                defaultUserAuthData: {
                    token: '',
                    isLoggedIn: '',
                    details: {}
                },
            }
        },
        methods: {
            login(data, redirect = '') {
                this.$store.commit('setUser', data);
                this.setLSToken(data.token);

                if(redirect)
                    this.$router.push(redirect)
                        .then((res) => {})
                        .catch((err) => {});
            },
            logout() {
                authService.setAuth(this.appToken);
                authService.logout()
                    .then((res) => {
                        this.$store.commit('setUser', this.defaultUserAuthData);
                        this.setLSToken('');
                        this.$router.push('/login').then((res) => {}).catch((err) => {});
                    })
                    .catch((err) => {
                        console.log(err.response);
                    });
            },
        }
    }
</script>